import useDialogStore from 'stores/dialogStore';
import type { DialogParams } from 'types/dialog';

/**
 * 다이얼로그를 컴포넌트 밖에서 여는 브리지 함수들
 * Vanilla JS 에서 사용
 */
const DialogBridge = {
  /** 확인이면 true, 취소·바깥 터치·뒤로가기면 false. */
  open: (params: DialogParams) => useDialogStore.getState().open(params),

  /** 코드로 닫을 때는 취소로 처리한다. */
  close: (id: string) => useDialogStore.getState().close(id, false),
  closeAll: () => useDialogStore.getState().closeAll(),

  /**
   * 뒤로가기 처리. 맨 위 다이얼로그를 닫고 true, 없으면 false.
   * 닫히지 않는 다이얼로그(dismissible: false)는 뒤로가기를 삼키기만 한다.
   */
  processBackButton: () => {
    const { dialogs, dismiss } = useDialogStore.getState();
    const top = dialogs[dialogs.length - 1];
    if (!top) return false;
    if (top.dismissible !== false) dismiss(top.id);
    return true;
  },
};

export default DialogBridge;
